export default "__VITE_ASSET__DSWALl7D__"